"use strict";
var rating_component_1 = require('./rating/rating.component');
exports.RatingComponent = rating_component_1.RatingComponent;



/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-bootstrap/components/rating.js
 ** module id = 825
 ** module chunks = 0
 **/